export default "__VITE_ASSET__j8Xaomhr__"